import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";

interface mutateProps {
  id: string;
  communityId: string;
  module: string;
  data: FieldValues
}

const mutateUpdatePropertyCategory = async ({ data, id, communityId, module }: mutateProps) => {
  return await axiosAuth.put(`v1/${module}/community/${communityId}/${id}`, data);
};

const useUpdatePropertyCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdatePropertyCategory,
    ...queryParams,
  });

export default useUpdatePropertyCategoryMutation;
